import React, { Component } from 'react';
import { AmityUiKitProvider } from '@frn/amityco-ui-kit-open-source';
import { connect } from 'react-redux';
import { actions as userActions } from 'modules/user';

const SocialPlusProvider = ({
  user,
  socialPlusApiKey,
  productSlug,
  retrieveSocialPlusToken,
  insecure,
  children,
  configs = {}
}) => {
  console.log('SocialPlusProvider', user, socialPlusApiKey, productSlug);
  const { userId, firstName, lastName } = user;
  const userIdString = userId.toString();
  const displayName = `${firstName} ${lastName.charAt(0).toUpperCase()}`;
  getAuthToken = async () => {
    const token = await retrieveSocialPlusToken(productSlug);
    return token;
  };
  return (
    <AmityUiKitProvider
      key={userId}
      apiKey={socialPlusApiKey}
      userId={userIdString}
      displayName={displayName}
      apiRegion={'US'}
      {...(!insecure ? { getAuthToken: getAuthToken } : {})}
      theme="light"
      configs={{
        excludes: ['community_profile_page/community_header/community_category', '*/*/copy_link_button'],
        ...configs,
        preferred_theme: 'light'
      }}
    >
      {children}
    </AmityUiKitProvider>
  );
};

// Redux Connect
const mapStateToProps = state => ({
  user: state.user
});

const mapDispatchToProps = dispatch => ({
  retrieveSocialPlusToken: productSlug => dispatch(userActions.retrieveSocialPlusToken(productSlug))
});

export default connect(mapStateToProps, mapDispatchToProps)(SocialPlusProvider);
